/* eslint-disable max-len */
import configService from './configservice';

export class DocumentConfigurationService  {
  TIER_TYPE_NONE = 'None';
  TIER_TYPE_STANDARD = 'Standard';
  TIER_TYPE_PREMIUM = 'Premium';
  TIER_TYPE_CUSTOM = 'Custom';
  ORIENTATION_VERTICAL = 'Vertical';
  ORIENTATION_HORIZONTAL = 'Horizontal';

  constructor(httpClient) {
    this.httpClient = httpClient;
  }
  
  getConfiguration() {
    return this.httpClient.get(`${configService.FulfillmentCustomizationApiUrl }/api/documentConfiguration/enabled-document`);
  }

  getGiftNotes() {
    return this.httpClient.get(`${configService.FulfillmentCustomizationApiUrl }/api/documentConfiguration/giftNote`)
      .then(response => {
        if(!response.data) {
          response.data = {
            tier: this.TIER_TYPE_NONE,
            orientation: this.ORIENTATION_HORIZONTAL,
          };
        }

        return response;
      });
  }

  updateGiftNotes(data) {
    return this.httpClient.put(`${configService.FulfillmentCustomizationApiUrl }/api/documentConfiguration/giftNote`, this._convertDataToFormData(data), this._getMultipartHeader());
  }

  getMarketingInserts() {
    return this.httpClient.get(`${configService.FulfillmentCustomizationApiUrl }/api/documentConfiguration/marketingInsert`)
    .then(response => {
      if(!response.data) {
        response.data = {
          tier: this.TIER_TYPE_NONE,
        };
      }

      return response;
    });
  }

  updateMarketingInserts(data) {
    return this.httpClient.put(`${configService.FulfillmentCustomizationApiUrl }/api/documentConfiguration/marketingInsert`, this._convertDataToFormData(data), this._getMultipartHeader());
  }

  _convertDataToFormData(data) {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });

    return formData;
  }

  _getMultipartHeader() {
    return {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };
  }
}
